module.exports = __webpack_public_path__ + "assets/img/23_21_big.add8a6c8.jpg";